<template>
    <div class="vx-card" id="cyber-security-product" v-if="coverageChart">
        <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Éstas son las coberturas que te recomendamos.</span>
         <br>
        <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;">Haz click sobre la cobertura para más detalle.</span>

        <div class="vx-col mt-3 red-border" >

            <div class="titles" style="display:block" >
                <div class="pb-2 pt-1 mt-2" id="titles">
                    <img src="../../../../assets/images/pages/eCommerce/umbrella.png">
                    <span class="packName">{{coverageChart.name}}</span><br>
                    <span class="packPrima">{{decimalNumberWithCommas(getReceipt())}}</span>
                    <span class="packUnits"> €/año</span>
                </div>
            </div>
            <div class="vx-col information" style="display:inline-block">
                <div class="vx-row ml-3 mb-1 product align">
                    <div class="vx-col sm:w-5/6 title">
                        Coberturas
                    </div>
                    <div class="vx-col sm:w-1/6 title" style="text-align: right; padding-right: 3%">
                        Capital
                    </div>
                </div>
                <vs-collapse accordion>
                    <div class="vx-row mb-1 product align" :key="indexCover" v-for="(cover, indexCover) in coverageChart.capitalOffer">
                        <div class="vx-col sm:w-5/6">
                                <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
                                    <div slot="header" class="title-font">{{cover.cover}}</div>
                                    <div class="text">
                                        {{cover.literalDescription}}
                                    </div>
                                </vs-collapse-item>
                        </div>
                        <div class="vx-col sm:w-1/6 capital" v-if="cover.capital > 1">
                            {{formatImporte(cover.capital)}}
                        </div>
                        <div class="vx-col sm:w-1/6 capital" v-if="cover.addedLiteral">
                            {{cover.addedLiteral}}
                        </div>
                        <div class="vx-col sm:w-1/6 capital" v-if="cover.capital == 1 && cover.addedLiteral == ''">
                            {{formatImporte(cover.capital)}}
                        </div>
                    </div>
                </vs-collapse>
            <div class="info-interested-div right-button" >
            <!-- Important the order of buttons, as direction is row-reverse: izq a dcha 
            To avoid movement of buttons when i button not showed  -->
                <vs-button
                    class="rounded-button"
                    @click="goToThirdStep()"
                    >
                    Me interesa
                    </vs-button>
                </div>
            </div>
        </div>

        <div class="pt-3">
            <navegation-buttons id="buttons"
                v-bind:code="code"
                v-bind:previus="previus"
                >
            </navegation-buttons>
                <!-- @nextStep="goToThirdStep()" -->
                <!-- v-bind:next="next" -->
        </div>

        <!-- <vs-popup  class="con-vs-popup bg-box-gradient-popup"  title="¿Hablamos?" :active.sync="callServicePopup">
            <call-service-popup
                v-bind:callServicePopup="callServicePopup"
                v-bind:callServiceType="callServiceType"
                @closeCallServicePopup="closeCallServicePopup"
            >
            </call-service-popup>
        </vs-popup>

        <div id="buttons-2" class="form-width" style="display:inline-block">
            <div  class="box-buttons mt-10">
                <div class="back-button no-fill-button">
                    <vs-button
                    class="vs-button previous-product"
                    @click="goToPreviusStep()"
                    >
                    Anterior
                    </vs-button>
                </div>
                <div class="call-button no-fill-button">
                    <vs-button
                        @click="callService()"
                    >
                    <img src="../../../../assets/images/logo/call-phone-icon.png" width="15px" height="15px"/>
                        Solicitar llamada
                    </vs-button>
                </div>
                

                <div class="next-button no-fill-button">
                    <vs-button
                        class="vs-button"
                        @click="goToThirdStep()"
                    >
                    Me interesa</vs-button>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
import CoverageChartComponent from '../coverage-chart/CoverageChartComponent.vue'
import vSelect from 'vue-select'
// import CallServicePopup from '../../../components/eprevision-components/callServicePopup/CallServicePopup.vue';
import NavegationButtons from '../../../components/eprevision-components/navegationButtons/NavegationButtons.vue'

export default {
  components: { 
      VxCard, 
      CoverageChartComponent,
    //   CallServicePopup ,
      vSelect,
      NavegationButtons
      },

    name: 'cyber-security-offer',
    props: {
        commercialOffer: Object,
        code: String,
        next: String,
        previus: String,
    },
    data() {
        return {
            offerCalculatedResponse: null,
            // callServiceType:"helpProcess",
            // callServicePopup: false,
            commercialOfferForm:null,
            commercialOfferResponse: null,
            dataStored: null,
            coverChart: null,
            dataTablePackage: [],
             offerCalculated: {
                profession: "",
                bornDate: "",
                regime: "",
                paymentType:"",
                covers: [],
                primaNeta: 0,
                primaTotal: 0,
                taxs: 0,
                receipt: 0,
                productCover: ""
            },
            formattedCapital:"",
            // offerCalculatedResponse: null,
            packCommercialOffers:[],
            offerCalculatedResponse: {
                coversResult: [],
                errorsInfo:  [],
                productCover: "",
                validate:"",
            },
            coverageChart: null,
            coverageChartPop: false,
            condCover: {
                label: null,
                value: null
            },
            chkCondCoverSelect: {
                label: null,
                value: null
            },
            condCoverFr: {
                label: null,
                value: null
            },
            chkCondValue: {
                label: null,
                value: null
            },
            errorCond: false,
            error_msg: [],
            ready: false,
        }
    },
    created() {
        this.dataStored = JSON.parse(localStorage.getItem(this.code))

        if (this.dataStored.initialData) {
            this.commercialOfferResponse = this.dataStored.initialData
            this.commercialOfferResponse.age = this.dataStored.initialData.age
            
        }

        this.getExtraProductCoverChart()
        
    },
    
    methods: {
        // callService() {
        //     this.callServicePopup = true;

        // },
        getReceipt(){
            let response = this.dataStored.initialData.cyberAttackValue + this.dataStored.initialData.identityFraudValue

            return response.toFixed(2)
        },
        // replaceDot(number){
        //     return number.replace('.',',')
        // },

        // closeCallServicePopup(value){
        //     this.callServicePopup = value;
        // },
        closeCoverageChartPop(value){
          this.coverageChartPop = value.closePop;
          if (value.packName != "") {

            this.goToThirdStep(value.packName)
          }  else{
            return true
          }
        },
        //  goToPreviusStep() {
        //     this.$router
        //     .push("/"+ this.previus + "-step/" + this.code)
        //     .catch(() => {});

        // },
        decimalNumberWithCommas(number) {
          if(number){
            let decimalCommaNumber = number.replace('.',',')
            return decimalCommaNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          }
        },
        //numberWithCommas(x) {
        //    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        //},

        formatImporte(importe){
        if(!isNaN(importe)){
        return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe.toFixed(2));
        }
        return importe;
        },
        makeTitle(name, receipt) {
            return name + ": " + receipt.toFixed(2) + "€/mes"
        },
        getExtraProductCoverChart() {

            let params = {
                type: "CS",
                singlePack: {
                    cyberSecurityCapital: this.dataStored.initialData.cyberAttack,
                    identityFraudCapital: this.dataStored.initialData.identityFraud
                }
            }

            this.$http.post(process.env.VUE_APP_BROKER_API + '/ext-prod-cover-chart/' + this.dataStored.extraProduct._id, params)
            .then((response) => {
                this.coverageChart = response.data.packOffer[0] 
                // console.log(this.coverageChart)
            })
        },
        goToThirdStep() {
            this.$vs.loading({ type: "sound" });

            this.dataStored.filesToSign = this.dataStored.extraProduct.requestId

            this.dataStored.pack = {
                cyberAttackValue: this.dataStored.initialData.cyberAttackValue,
                identityFraudValue: this.dataStored.initialData.identityFraudValue,
                cyberAttack: this.dataStored.initialData.cyberAttack,
                identityFraud: this.dataStored.initialData.identityFraud
            }
            localStorage.setItem(this.code, JSON.stringify(this.dataStored))

            let params = {
                extraProductCode: this.code,
                minBilling: this.dataStored.initialData.minBilling,
                maxBilling: this.dataStored.initialData.maxBilling,
                packName: this.coverageChart.name,
                primaNeta: parseFloat(this.dataStored.initialData.cyberAttackValue + this.dataStored.initialData.identityFraudValue),
                capitalToCover: parseFloat(this.dataStored.initialData.cyberAttack + this.dataStored.initialData.identityFraud),
                leadType:"CyberSecurity"
            }

            // var windowReference = window.open();
            
            this.$http.patch(process.env.VUE_APP_BROKER_API + '/initial-data/' + this.dataStored.initialData.initialDataId, params)
            .then((responsePatch) => {
                // this.closeLoader = setInterval(async () => {
                //     this.localDataStored = JSON.parse(localStorage.getItem(this.code))
                //     if (this.localDataStored.signed == true)  {
                //         // Delete localStorage 
                //         localStorage.removeItem(this.code);

                //         this.$vs.loading.close()
                //         clearInterval(this.closeLoader)
                //         this.$router
                //             .push("/extra-products/" +  this.code)
                //             .catch(() => {});
                //     }
            
                // }, 15000)
            // Changed as the window.open was blocked in IOS 
            // windowReference.location = process.env.VUE_APP_DOMAIN + '/' + this.next + '-step/' + this.code;
                   
            // window.open(process.env.VUE_APP_DOMAIN + "/" + this.next + "-step/" + this.code, '_blank');

            this.$router
            .push("/" + this.next + "-step/" + this.code)
            .catch(() => {});

            })
        },
    }
}
</script>
<style lang="scss">

#cyber-security-product {
    // width: 95% !important; 
    // margin-left: 2.5% !important;
    // margin-right: 2.5% !important;

    .information{
        width:98%;
        // margin: auto;
    }
    // .vx-row vx-col{
    //     margin-left: 0px !important; 
    // }
    .text{
        font-weight: 400;
        font-size: 13px !important;
        margin-bottom: 6px;
        }

    .title{
        font-weight: bold
    }

    .vs-collapse {
        padding: 0px !important;
    }
    .vs-collapse-item--icon-header {

        left: 0px !important;
    }
    .vs-collapse-item--header {
        padding: 0px 10px !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        margin-top: 2px;
        margin-bottom: 2px;


    }
    .con-content--item {
        padding: 0px 10px !important;
        font-size: 11px !important;
    }
    .align {
          display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        justify-content: space-between;  
    }
    .capital {
        text-align: right !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        margin-top: 2px;
    }
    // .product-item {
    //     // border: 1px solid var(--vs-secundary)  !important;
    //     //  border:1px solid rgba(var(--vs-secundary), 0.2) !important;

    //     // background-color: rgba(var(--vs-secundary), 0.1);
    //     border-radius: 5px;
    // }
    .titles {
        display: flex !important;
        flex-direction:column;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: stretch;
    }

    div[comma-value]{
    position:relative;
    }
    div[comma-value]:before{
        content: attr(comma-value);
        position:absolute;
        left:0;
    }
    div[comma-value] input{
        color:#fff;
    }

    .form-width {
            font-weight: bold;
            width: 100%;
        }

    #titles {
        img{
            width: 70px;
            height: 70px;
            display:block;
            margin:auto;
            }
    }


    .image {
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
    }

    .product {
        padding-left: 10px;
        padding-right: 10px;

        .vs-col .vs-col {
          width: 100%;
        }
        .md-list-item-container {
            font-size:11px !important;
        }
    }

     .call-button{
         .vs-button{
             float: none !important;
         }
     }
        
    @media only screen and (max-width : 600px){       
        .call-button{
            .vs-button{
                float: center !important;
            }
        }


        .vx-row .vx-col {
        padding: 0 0rem;
        .config-cell{
            width: 100%;
        }
        }

        .product {
            text-align: left !important;
        }

        .product .price {
        text-align: right !important;
        }

      }
    

    @media screen and (min-width : 601px)
      and (max-width : 759px) {     
    // #single-product{

        .call-button{
            .vs-button{
                float: none !important;
            }
        }

        .vx-row .vx-col {
        padding: 0 0rem;
        .config-cell{
            width: 100%;
        }
        }

        .product {
            text-align: left !important;
        }

        .product .price {
        text-align: right !important;
        }

}
    
    @media only screen and (min-width : 760px)
  and (max-width : 1100px) {

      
        .vx-row .vx-col {
            padding: 0 0rem;
            .config-cell{
                width: 100%;
         
            }
        }

        .product {
            text-align: left !important;
        }

        .product .price {
        text-align: right !important;
        }

        
        .call-button{
            .vs-button{
                float: none !important;
            }
        }


    }

    // @media screen and (min-width: 851px) {
    @media screen and (min-width: 1101px) {
        
        .two-in-row {
                display: flex !important;
                flex-wrap: nowrap;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            
        }


        .vx-row .vx-col {
        padding: 0 0rem;
        .config-cell{
            width: 47%;
            }
        }

        .call-button{
            .vs-button{
                float: none !important;
            }
        }

        .product {
        text-align: left !important;
        }

        .product .price {
        text-align: right !important;
        }



    }
}
</style>